import { UserProfile, UserProfileJSON } from "models/UserProfile";
import { callGet, callPost, laravelApiV3 } from "./index";
import { retryOnException } from "./retries";
import { LARAVEL_APP_API } from "../constants";

// The user profile api can handle all profile fields and some user fields
type UserProfileAPIJSONFields = UserProfileJSON & { phone?: null | string }

export class UserProfileAPI {
  static async update(profile: UserProfileAPIJSONFields): Promise<boolean> {
   
    // for profiles, don't provide email because it will assume you want to change the email,
    // and will then error out if the email already exists (which it will)
    if(profile.email) {
        console.warn("not updating user email")
        profile.email = undefined //profileJson.email || myUser.email
    }
    // Don't pass weird negative dates
    if(profile.birthdate && (profile.birthdate.startsWith('-') || !Date.parse(profile.birthdate))) {
      console.warn("invalid birthdate", profile.birthdate)
      profile.birthdate = undefined
    }
    if (profile.birthdate && profile.birthdate.indexOf("T") === -1) {
      profile.birthdate = profile.birthdate.split(" ")[0] + "T00:00:00Z"
    }
    profile.created_at = undefined
    profile.updated_at = undefined
    console.log("birthdate", profile.birthdate)


    return await retryOnException(async () => {
      try {
        const path = `users/${profile.user_id}/profile`;
        callPost(path, profile)
        return true
      } catch (e) {
        console.error((e as any)?.message)
        return false
      }
    }, 6, 750)
  }

  static async get(userId:number): Promise<UserProfile|undefined> {
    return await retryOnException(async () => {
      const path = `users/${userId}/profile`;
      const profileResponse = await callGet(path, false);
      const profileJSON = profileResponse?.data
      const userProfile = UserProfile.fromJSON(profileJSON)
      if(!userProfile) {
        return undefined
      }

      return userProfile
    }, 6, 750)
  }

  static async getAvatar(userId:number, profilePicBucketKey:string, avatarDimensions:string): Promise<any> {
    const path =  `users/${userId}/avatar/${profilePicBucketKey}/${avatarDimensions}`
    const avatarResponse = await callGet(path, false, {responseType:"arraybuffer"})

    if(!avatarResponse) {
      return
    }

    const base64 = btoa(
      new Uint8Array(avatarResponse.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ''
      )
    )
    return base64
  }
}
